import styled from 'styled-components';
import {ReservationTypeForm} from 'components/ReservationSettingsModal';
import {DEVICE} from '@chekin/guestapp-ui-kit';

export const StyledReservationTypeForm = styled(ReservationTypeForm)`
  margin-top: 24px;

  & .multi-radio {
    width: 100%;
  }

  & .multi-radio__option {
    padding: 16px;
    border-radius: 12px;
    background: ${props => props.theme.colors.branding.boxesModals};
    box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.07);
  }

  & .multi-radio-option_checked {
    border: 1px solid ${props => props.theme.colors.branding.primary};
  }

  @media (min-width: ${DEVICE.laptop}) {
    & .multi-radio {
      max-width: 327px;
    }

    & .chekin-button_primary {
      max-width: 327px;
      margin: 48px auto 0;
    }
  }
`;
